import { toast } from 'react-toastify';

type ErrorData = {
  error: string;
  property: string;
};

type ErrorPayload = {
  message: string;
  data?: string | ErrorData[];
};

//TODO: it will be a nice change to make a toast service, to use success, warn, etc, and be used after adding a new template for example

export const formatToastError = ({ message, data }: ErrorPayload) => {
  if (data && typeof data === 'string') {
    return toast.error(`${message} - ${data}`);
  }
  if (data && Array.isArray(data)) {
    data.forEach(el => {
      toast.error(`${message} - ${el.error}`);
    });
  }
  return toast.error(`${message}`);
};
